/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".change-password[_ngcontent-%COMP%]{font-size:18px!important;color:#0f7cb6;cursor:pointer}.change-password[_ngcontent-%COMP%]:hover{color:#cd4927}.margin-left-sm[_ngcontent-%COMP%]{margin-left:5px!important}"];
export { styles as styles };
